module.exports = __webpack_public_path__ + "img/imagen10.da0d0247.png";